<template>
  <Header></Header>
  <SideBar></SideBar>

  <Body pageTitle="Base Cost">
    <template v-slot:body>
      <TableList :config="config()"></TableList>
    </template>
  </Body>
</template>

<script>
import Header from '@/layouts/Header.vue'
import SideBar from '@/layouts/SideBar.vue'
import Body from '@/layouts/Body.vue'
import TableList from './TableList.vue'
export default {
  components: {
    Header,
    SideBar,
    Body,
    TableList
  },
  methods: {
    config() {
      return {
        showTableFilters: true,
        preload: true,
        tableId: 'base-cost',
        indexUri: 'base-cost',
        storeId: ['main']
      }
    }
  }
}
</script>
